import { Route } from '@angular/router';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';
import {AuthGuard} from './core/auth/guards/auth.guard';
import {ProfileMatrixComponent} from "./main/profile-matrix/profile-matrix.component";
import { DigitalTagsComponent } from './main/digital-tags/digital-tags.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    {path: '', pathMatch : 'full', redirectTo: 'login'},
    {path: 'sign-in', pathMatch : 'full', redirectTo: 'login'},
    // Redirect signed in user to the '/example'
    //
    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'home'},

    // Auth routes for guests
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/main/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule)},
            {path: 'login', loadChildren: () => import('app/main/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule)},
            {path: 'sign-up', loadChildren: () => import('app/main/auth/sign-up/sign-up.module').then(m => m.AuthSignUpModule)},
            { path: 'unauthorized', redirectTo: 'login' },
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/main/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule)},
        ]
    },

    // Landing routes
    // {
    //     path: '',
    //     component  : LayoutComponent,
    //     data: {
    //         layout: 'empty'
    //     },
    //     children   : [
    //         {path: 'home', loadChildren: () => import('app/main/landing/home/home.module').then(m => m.LandingHomeModule)},
    //     ]
    // },

    // Admin routes
    {
        path       : '',
        canActivate: [AuthGuard],
        component  : LayoutComponent,
        resolve    : {
            initialData: InitialDataResolver,
        },
        children   : [
            { path: 'home', loadChildren: () => import('app/main/home/home.module').then(m => m.HomeModule) },
            { path: 'accounts', loadChildren: () => import('app/main/accounts/accounts.module').then(m => m.AccountsModule) },
            {path: 'dashboard', loadChildren: () => import('app/main/dashboard/dashboard.module').then(m => m.DashboardModule)},
            {path: 'example', loadChildren: () => import('app/main/example/example.module').then(m => m.ExampleModule)},
            { path: 'teams', loadChildren: () => import('app/main/teams/teams.module').then(m => m.TeamsModule) },
            { path: 'users', loadChildren: () => import('app/main/users/users.module').then(m => m.UsersModule) },
            { path: 'unavailable-codes', loadChildren: () => import('app/main/unavailable-codes/unavailable-codes.module').then(m => m.UnavailableCodesModule) },
            { path: 'address-books', loadChildren: () => import('app/main/address-books/address-books.module').then(m => m.AddressBooksModule) },
            { path: 'profile-matrix', component: ProfileMatrixComponent },
            { path: 'digital-tags', component: DigitalTagsComponent },
            { path: 'advanced-team-assignment-wizard', loadChildren: () => import('app/main/advance-team-skill/advance-team-skill.module').then(m => m.AdvanceTeamSkillModule) },
            { path: 'sky-data', loadChildren: () => import('app/main/sky-data/sky-data.module').then(m => m.SkyDataModule) },
            { path: 'feedback', loadChildren: () => import('app/main/feedback/feedback.module').then(m => m.FeedbackModule) },
            { path: 'calling-lists', loadChildren: () => import('app/main/calling-lists/calling-lists.module').then(m => m.CallingListsModule) },
            { path: 'campaigns', loadChildren: () => import('app/main/campaigns/campaigns.module').then(m => m.CampaignsModule) },
            { path: 'dispositions', loadChildren: () => import('app/main/dispositions/dispositions.module').then(m => m.DispositionsModule) },
            { path: 'skills', loadChildren: () => import('app/main/skills/skills.module').then(m => m.SkillsModule) },
            { path: 'points-of-contact', loadChildren: () => import('app/main/points-of-contact/points-of-contact.module').then(m => m.PointsOfContactModule) },
            { path: 'hours-of-operation', loadChildren: () => import('app/main/hours-of-operation/hours-of-operation.module').then(m => m.HoursOfOperationModule) },
            { path: 'studio-scripts', loadChildren: () => import('app/main/studio-scripts/studio-scripts.module').then(m => m.StudioScriptsModule) },
            { path: 'apps/file-manager', loadChildren: () => import('app/main/file-manager/file-manager.module').then(m => m.FileManagerModule) },
            { path: 'dnc-groups', loadChildren: () => import('app/main/dncGroups/dnc.module').then(m => m.DncModule) },
            { path: 'tags', loadChildren: () => import('app/main/tags/tags.module').then(m => m.TagsModule) },
        ]
    }
];
